<template>
  <div>
    <home-common-search :from="'home'"></home-common-search>
    <div class="lang" @click="setLang"><img :src="getFlagUrl()"/></div>
    <div class="cart" @click="goCart">
      <img src="../../../assets/image/cart.png"/>
    </div>
    <body>
      <div style="padding-bottom: 100px">
        <div class="container" v-show="!special || !special['index/index']">
          <index-banner
            v-if="banners && banners.length > 0"
            :items="banners"
          ></index-banner>
          <mt-swipe
            class="banner"
            style="height: 4.1rem; margin: 0.4rem 0.7rem 1rem"
            :speed="600"
            :show-indicators="false"
          >
            <mt-swipe-item>
              <img
                src="../../../assets/image/home/gobuy.png"
                @click="gotobuy"
                alt="gobuy"
              />
            </mt-swipe-item>
            <mt-swipe-item>
              <img
                src="../../../assets/image/im.png"
                @click="gotoIm"
                alt="gobuy"
              />
            </mt-swipe-item>
          </mt-swipe>

          <CategoryCarousel v-if="class_list.length > 0" :data="class_list" />

          <index-three-ads :items="promotionAds"></index-three-ads>

          <div class="tabs">
            <div
              class="tab"
              v-for="(item, index) in tabs"
              :key="index"
              :class="{ active: index === activeTab }"
              @click="tabClick(item, index)"
            >
              {{ $t(item.gc_name) }}
            </div>
          </div>

          <index-floor-ads v-if="floorAds" :ad="floorAds[0]"></index-floor-ads>

          <index-product-list
            :items="list"
            :type="popular"
            v-if="list && list.length > 0"
          ></index-product-list>

          <index-floor-ads v-if="floorAds" :ad="floorAds[1]"></index-floor-ads>

          <div class="copyright">
            <div class="item appType">
              <div class="t">{{ $t("Download our app") }}</div>
              <div class="list">
                <div class="iit">
                  <div class="l icon">
                    <img src="../../../assets/image/home/pg.png" alt="pg" />
                  </div>
                  <div class="r">
                    <div class="t">{{ $t("Download it from") }}</div>
                    <div class="tt">APP STORE</div>
                  </div>
                </div>

                <div class="iit">
                  <div class="l icon">
                    <img src="../../../assets/image/home/gg.png" alt="gg" />
                  </div>
                  <div class="r">
                    <div class="t">{{ $t("Download it from") }}</div>
                    <div class="tt">GOOGLE PLAY</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="item_con">
              <div class="item" @click="gotoFuwenben(2, 'account')">
                <div class="t">{{ $t("Account correlation") }}</div>
                <div class="text" v-for="item in bomList1">
                  {{ item.question }}
                </div>
              </div>
              <div class="item" @click="gotoFuwenben(2, 'order')">
                <div class="t">{{ $t("Order management") }}</div>
                <div class="text" v-for="item in bomList2">
                  {{ item.question }}
                </div>
              </div>
              <div class="item" @click="gotoFuwenben(2, 'pay')">
                <div class="t">{{ $t("Payment method") }}</div>
                <div class="text" v-for="item in bomList3">
                  {{ item.question }}
                </div>
              </div>
              <div class="item" @click="gotoFuwenben(2, 'shipping')">
                <div class="t">{{ $t("Shipping and distribution") }}</div>
                <div class="text" v-for="item in bomList4">
                  {{ item.question }}
                </div>
              </div>
              <div class="item" @click="gotoFuwenben(2, 'refund')">
                <div class="t">{{ $t("Return and exchange policy") }}</div>
                <div class="text" v-for="item in bomList5">
                  {{ item.question }}
                </div>
              </div>
              <div class="item" @click="gotoFuwenben(2, 'service')">
                <div class="t">{{ $t("Customer service") }}</div>
                <div class="text" v-for="item in bomList6">
                  {{ item.question }}
                </div>

                <div class="text" @click.stop="gotoFuwenben(1)">
                  {{ $t("About Us") }}
                </div>
                <div class="text" @click.stop="getEmail">
                  {{ $t("Contact us") }}
                </div>
              </div>
              <div class="item" @click="gotoFuwenben(2, 'security')">
                <div class="t">{{ $t("Privacy Policy and Terms of Use") }}</div>
                <div class="text" v-for="item in bomList7">
                  {{ item.question }}
                </div>
              </div>
            </div>
            <div class="icons">
              <div class="icon" v-for="item in iconList">
                <a :href="item.link" target="_blank">
                  <img :src="item.src" />
                </a>
              </div>
            </div>
            <div class="item" style="margin-bottom: 20px">
              <div class="text">
                {{ $t("address") }}:
                {{ "4255 South Buckley Road #1296 Aurora CO 80013 USA" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </body>

    <audio
      src="../../../assets/image/gobuy/44s.mp3"
      muted
      style="display: none"
    ></audio>
    <audio
      src="../../../assets/image/gobuy/15s.mp3"
      muted
      style="display: none"
    ></audio>
  </div>
</template>

<script>
import store from '../../../store';
import {
  Goodsclass,
  goods_index_list,
  get_contact_info,
} from "../../../api/homeindex";
import { getAboutContent } from "../../../api/homeArticle";
import { getAddressInfo } from "../../../api/memberBuy";
import { mapState, mapActions } from "vuex";
import { Toast } from "mint-ui";
import IndexProductList from "./IndexProductList";
import HomeCommonSearch from "../common/HomeCommonSearch";
import IndexBanner from "./IndexBanner";
import IndexFloorAds from "./IndexFloorAds";
import IndexThreeAds from "./IndexThreeAds";
import CategoryCarousel from "./CategoryCarousel";
export default {
  name: "HomeIndex",
  data() {
    return {
      lang_img: '',
      isshowBacktop: true,
      popular: "",
      sale: "goods_salenum",
      recently: "goods_addtime",
      tabs: [
        {
          gc_name: "TodaysOffer",
        },
      ],
      activeTab: 0,
      list: [],
      chartInstance: null,
      slots: [
        {
          values: [],
        },
      ],
      popupVisible: false,
      class_list: [],
      bomList1: [],
      bomList2: [],
      bomList3: [],
      bomList4: [],
      bomList5: [],
      bomList6: [],
      bomList7: [],
      iconList: [
        {
          src: require("../../../assets/image/home/b1.png"),
          type: "Facebook",
        },
        {
          src: require("../../../assets/image/home/b2.png"),
          type: "Twitter",
        },
        {
          src: require("../../../assets/image/home/b3.png"),
          type: "YouTube",
        },
        {
          src: require("../../../assets/image/home/b4.png"),
          type: "Instagram",
        },
        {
          src: require("../../../assets/image/home/b5.png"),
          type: "LinkedIn",
        },
        {
          src: require("../../../assets/image/home/b6.png"),
          type: "TikTok",
        },
      ],
      address_info: null,
    };
  },
  components: {
    IndexProductList,
    HomeCommonSearch,
    IndexBanner,
    IndexFloorAds,
    IndexThreeAds,
    CategoryCarousel,
  },
  mounted() {
    getAboutContent("account").then((res) => {
      this.bomList1 = res.result.list;
    });
    getAboutContent("order").then((res) => {
      this.bomList2 = res.result.list;
    });
    getAboutContent("pay").then((res) => {
      this.bomList3 = res.result.list;
    });
    getAboutContent("shipping").then((res) => {
      this.bomList4 = res.result.list;
    });
    getAboutContent("refund").then((res) => {
      this.bomList5 = res.result.list;
    });
    getAboutContent("service").then((res) => {
      this.bomList6 = res.result.list;
    });
    getAboutContent("security").then((res) => {
      this.bomList7 = res.result.list;
    });
    getAddressInfo().then((res) => {
      if (res.code == 10000) {
        this.address_info = res.result;
      }
    });
    Goodsclass().then((res) => {
      this.class_list = res.result;
      this.getList();
    });
  },
  created: function () {
    this.utils.preloadImages([
      "https://storage.googleapis.com/gobuy-goods-img/static/box/1.gif",
      "https://storage.googleapis.com/gobuy-goods-img/static/box/2.gif"
    ]);

    get_contact_info().then((res) => {
      // this.list = res.result.goods_list
      // 遍历 iconList 并添加 link 属性
      this.iconList.forEach((icon) => {
        // 查找与 type 匹配的链接
        const link = res.data[icon.type];
        // 如果找到了链接，则添加到当前 icon 对象
        if (link) {
          icon.link = link;
        }
      });
    });

    this.fetchHomeAd({}).then(
      (response) => {},
      (error) => {
        Toast(error.message);
      }
    );
    this.fetchHomeArticle({}).then(
      (response) => {},
      (error) => {
        Toast(error.message);
      }
    );
    // this.fetchHomeProduct({}).then(
    //   (response) => {},
    //   (error) => {
    //     Toast(error.message);
    //   }
    // );
    this.fetchConfig({}).then(
      (response) => {},
      (error) => {
        Toast(error.message);
      }
    );
  },
  computed: {
    ...mapState({
      special: (state) => state.home.special,
      config: (state) => state.config.config,
      banners: (state) => state.home.banners,
      navs: (state) => state.home.navs,
      floorAds: (state) => state.home.floorAds,
      promotionAds: (state) => state.home.promotionAds,
      articles: (state) => state.home.articles,
      hotProducts: (state) => state.home.hotProducts,
      recentlyProducts: (state) => state.home.recentlyProducts,
      goodProducts: (state) => state.home.goodProducts,
    }),
  },
  methods: {
    ...mapActions({
      fetchHomeAd: "fetchHomeAd",
      fetchHomeArticle: "fetchHomeArticle",
      // fetchHomeProduct: "fetchHomeProduct",
      fetchConfig: "fetchConfig",
    }),
    getFlagUrl() {
      let lang = (localStorage.getItem('lang') || 'enus').toLowerCase().replace(/"/g, '');
      switch (lang) {
        case 'french':
          lang = 'fra';
          break;
        case 'thai':
          lang = 'tai';
          break;
        case 'korean':
          lang = 'kr';
          break;
        case 'vietnamese':
          lang = 'vit';
          break;
        case 'indonesia':
          lang = 'bah';
          break;
        case 'german':
          lang = 'deu';
          break;
        case 'tw':
          lang = 'TW';
          break;
        case 'hindi':
          lang = 'hindi';
          break;
        case 'urdu':
          lang = 'urdu';
          break;
        case 'jap':
          lang = 'jap';
          break;
        case 'enuk':
          lang = 'enuk';
          break;
        default:
          lang = 'enus'
          break;
      }
      return require(`@/assets/image/flag/${lang}.png`);
    },
    gotoFuwenben(id, type) {
      this.$router.push({
        name: "HomeDocument",
        query: { id: id, type: type },
      });
    },
    getEmail() {
      this.$router.push({ name: "MemberContactUs" });
    },
    tabClick(item, index) {
      this.activeTab = index;

      this.getList(item.id);
    },
    getList(id) {
      goods_index_list(id).then((res) => {
        this.list = res.result.goods_list;
      });
      // GoodsList(id).then(res => {
      //   this.list = res.result.goods_list
      // })
    },
    gotobuy() {
      if(store.state.member.token == 'null'){
        this.$router.push({ name: "HomeMemberLogin" });
      }else{
        this.$router.push({ name: "HomeGoBuy" });
      }
    },
    gotoIm() {
      if(store.state.member.token == 'null'){
        this.$router.push({ name: "HomeMemberLogin" });
      }else{
        window.location.href = '/im/?token='+store.state.member.token
      }
    },
    goGiftSave() {
      this.$router.push({
        name: "GiftSave",
      });
    },
    setLang() {
      this.$router.push({ name: "HomeLang" });
    },
    goCart() {
      this.$router.push({ name: "HomeCart" });
    },
    onValuesChange(picker, values) {
      this.product = values[0].en;
    },
  },
};
</script>

<style scoped lang="scss">
body {
  width: 100%;
  background-color: transparent;
  position: fixed;
  top: 100px;
  height: 100vh;
  overflow-y: auto;
}
.copyright {
  position: relative;
  background-position: center 50%;
  font-size: $fontSize;
  color: #c5c5c5;
  text-align: center;
  margin: 1rem 0;
  padding: 1rem;
  // 头部背景图片
  .header_box {
    position: absolute;
    top: 0;
    z-index: 0;
    img {
      width: 100%;
    }
  }
  // 下载软件
  .appType {
    .list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .iit:nth-child(1) {
        margin-right: 5px;
      }
      .iit:nth-child(2) {
        margin-left: 5px;
      }
    }
  }
  .item {
    padding: 0.4rem 0;
    &:first-child {
      border-bottom: 1px solid #bdbdbd;
    }

    .t {
      text-align: left;
      font-size: 0.8rem;
      color: #000;
      font-weight: 600;
    }

    .list {
      .iit {
        width: 8rem;
        margin: 15px 0;
        padding: 10px;
        background: #ffffff;
        border-radius: 5px 5px 5px 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .icon {
          img {
            width: 30px;
            display: block;
          }
        }

        .r {
          .t {
            font-size: 12px;
            color: #8a8099;
            margin: 0;
          }

          .tt {
            font-size: 14px;
            font-weight: 600;
            color: #000;
          }
        }
      }
    }

    .text {
      text-align: left;
      margin: 0.5rem 0;
      color: #7f7f7f;
    }
  }
  .item_con {
    display: flex;
    overflow-x: auto;
    .item {
      margin-right: 10px;
      &:first-child {
        border-bottom: 1px solid #bdbdbd;
      }

      .t {
        width: 200px;
        text-align: left;
        font-size: 0.8rem;
        color: #000;
        font-weight: 600;
      }

      .list {
        .iit {
          padding: 10px;
          background: #ffffff;
          border-radius: 5px 5px 5px 5px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .icon {
            img {
              width: 30px;
              display: block;
            }
          }

          .r {
            .t {
              font-size: 12px;
              color: #8a8099;
              margin: 0;
            }

            .tt {
              font-size: 14px;
              font-weight: 600;
              color: #000;
            }
          }
        }
      }

      .text {
        text-align: left;
        margin: 0.5rem 0;
        color: #7f7f7f;
      }
    }
  }
  .item_con::-webkit-scrollbar {
    display: none; /* 隐藏滚动条 */
  }

  .icons {
    margin-top: 25px;
    display: flex;
    justify-content: center;
    align-items: center;

    .icon {
      margin-right: 20px;
      width: 1rem;
      height: 1rem;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .link {
    color: #c5c5c5;
  }
}

.tabs {
  position: relative;
  padding-left: 0.7rem;
  padding-right: 0.7rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.5rem;
  height: 1.5rem;
  .tab {
    text-align: center;
    font-size: 18px;
    color: #333;
    padding: 7px 0px;
  }

  .active {
    color: black;
    border-radius: 2.5px;
    border-bottom: none; /* 取消默认下划线 */
    background-image: linear-gradient(
      90deg,
      #e8090c 30%,
      #f3611e 20%,
      RGBA(240, 240, 240, 1) 50%
    );
    background-size: 100% 5px; /* 下划线的高度 */
    background-repeat: no-repeat;
    background-position: bottom;
  }
}

.banner_ {
  margin: 0 10px 30px;

  img {
    width: 100%;
    height: 100%;
  }
}

.lang {
  position: fixed;
  top: 15px;
  right: 50px;
  z-index: 199;

  img {
    width: 1.5rem;
  }
}
.cart {
  position: fixed;
  top: 15px;
  right: 12px;
  z-index: 199;

  img {
    width: 1.3rem;
  }
}

.picker-toolbar-title {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  background: #f5f5f5;
}

.usi-btn-cancel,
.usi-btn-sure {
  color: #108ee9;
}

::v-deep .product-list-header {
  padding-left: 0;
  padding-right: 40px;

  .slot {
    width: 5.5rem !important;
  }
}

::v-deep .picker {
  .picker-items {
    width: 100%;
  }

  .picker-slot {
    flex: 1;
  }
}

.banner {
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
